<mat-card>
  <mat-card-title>{{ title() }}</mat-card-title>
  <mat-card-content>
   <div class="chart-container" #chart></div>
  </mat-card-content>

</mat-card>
